export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      about: "À Propos", 
      contact: "Contact",
      quote: "Demande de devis"
    },
    
    // Header
    header: {
      phone: "506-588-4919",
      email: "aymorenov25@gmail.com",
      hours: "Lun-Ven: 8h-17h | Sam: 9h-15h",
      quoteButton: "Demande de devis"
    },

    // Home Page
    home: {
      // Hero Section
      heroTitle: "Transformez votre maison",
      heroSubtitle: "avec AYMORENOV",
      heroTagline: "INTÉRIEUR OU EXTÉRIEUR, PETITS OU GRANDS TRAVAUX",
      heroTaglineSecond: "on s'en occupe !",
      heroDescription: "Votre partenaire de confiance pour tous vos projets de rénovation résidentielle.",
      whatsappButton: "💬 Contact WhatsApp",
      learnMoreButton: "En savoir plus",

      // Realizations Section
      realizationsTitle: "Nos Réalisations AYMORENOV",
      realizationsDescription: "Découvrez la qualité de nos travaux à travers ces projets réalisés par Mohamed Obad et son équipe",
      flooringInstallation: "Installation Planchers",
      flooringDescription: "Finition professionnelle",
      insulationWork: "Isolation & Structure", 
      insulationDescription: "Construction experte",
      asphaltWork: "Asphalte Chaud/Froid",
      asphaltDescription: "Entrées de qualité",
      kitchenRenovation: "Rénovation Cuisine",
      kitchenDescription: "Design moderne",
      realizationsCTA: "Contactez-nous pour vos projets",

      // Services Section
      servicesTitle: "Nos Services de Rénovation",
      servicesDescription: "Des solutions complètes pour tous vos besoins de rénovation résidentielle",
      contactForQuote: "Contactez-nous pour un devis personnalisé",
      whatsappQuote: "💬 Demander un devis WhatsApp",

      // Why Choose Us Section
      whyChooseTitle: "Pourquoi Choisir AYMORENOV ?",
      whyChooseDescription: "Ce qui nous distingue dans l'industrie de la rénovation",

      // Testimonials Section
      testimonialsTitle: "Ce que disent nos clients",
      testimonialsDescription: "La satisfaction de nos clients est notre plus grande récompense",
      shareExperienceTitle: "Partagez votre expérience avec AYMORENOV",
      shareExperienceDescription: "Votre avis nous aide à améliorer nos services et guide d'autres clients",
      yourName: "Votre nom",
      enterName: "Entrez votre nom",
      city: "Ville",
      yourCity: "Votre ville",
      projectType: "Type de projet réalisé",
      projectPlaceholder: "Ex: Rénovation de cuisine, Pavé extérieur...",
      yourRating: "Votre note",
      yourComment: "Votre commentaire",
      commentPlaceholder: "Décrivez votre expérience avec AYMORENOV...",
      publishReview: "Publier mon avis",

      // CTA Section
      ctaTitle: "Prêt à Transformer Votre Maison ?",
      ctaDescription: "Contactez Mohamed Obad dès aujourd'hui pour une consultation gratuite et découvrez comment AYMORENOV peut donner vie à vos projets de rénovation.",
      whatsappDirect: "💬 WhatsApp Direct",
      contactForm: "Formulaire de Contact"
    },

    // About Page
    about: {
      missionTitle: "Notre mission",
      missionIntro: "Depuis sa fondation, AYMORENOV Construction inc. s'est imposée comme un pilier de confiance dans le domaine de la construction et de la rénovation. Spécialisée dans les projets résidentiels, commerciaux et industriels, notre entreprise marie savoir-faire traditionnel et innovations modernes pour offrir des résultats durables, esthétiques et conformes aux plus hauts standards de qualité.",
      missionStatement: "Notre mission est simple mais ambitieuse : réaliser vos projets avec professionnalisme, intégrité et excellence. Nous nous engageons à :",
      commitment1: "Comprendre vos besoins et attentes pour vous proposer des solutions sur mesure.",
      commitment2: "Utiliser des matériaux de qualité et des techniques éprouvées pour garantir la durabilité et la sécurité.",
      commitment3: "Respecter les délais et les budgets convenus, tout en maintenant un niveau de communication transparent à chaque étape.",
      commitment4: "Favoriser une approche écoresponsable, en minimisant l'impact environnemental de nos chantiers.",
      valuesTitle: "Nos Valeurs Fondamentales",
      valuesDescription: "Ce qui guide notre travail au quotidien et fait de nous un partenaire de confiance",
      ctaTitle: "Rejoignez la Famille AYMORENOV",
      ctaDescription: "Faites confiance à notre expérience et notre passion pour transformer votre maison. Contactez-nous dès aujourd'hui pour démarrer votre projet.",
      freeQuoteButton: "Demander un Devis Gratuit",
      viewRealizationsButton: "Voir Nos Réalisations"
    },

    // Services Data 
    services: {
      kitchenReno: {
        title: "Rénovation de cuisine",
        description: "Transformation complète de votre cuisine avec design moderne et fonctionnel",
        features: ["Électricité et plomberie", "Carrelage", "Consultation des équipements"]
      },
      bathroomReno: {
        title: "Rénovation de salle de bain", 
        description: "Création d'espaces détente modernes et accessibles",
        features: ["Plomberie", "Carrelage et céramique", "Éclairage LED", "Accessibilité universelle"]
      },
      exteriorReno: {
        title: "Rénovation extérieure",
        description: "Amélioration de l'apparence et de la performance énergétique", 
        features: ["Toiture", "Revêtement extérieur", "Isolation", "Terrasses et patios", "Clôture extérieur des jardins"]
      },
      flooring: {
        title: "Planchers et revêtements",
        description: "Installation de planchers durables et esthétiques",
        features: ["Bois franc", "Céramique et porcelaine", "Vinyle de luxe", "Tapis et moquette"]
      },
      cleaning: {
        title: "Nettoyage",
        description: "Nettoyage après finissions des travaux",
        features: ["Nettoyage après finissions des travaux"]
      },
      paving: {
        title: "Pavé et asphalte",
        description: "Pavé extérieur et asphalte chaud/froid", 
        features: ["Pavé extérieur", "Asphalte chaud/froid"]
      }
    },

    // Company Values
    values: {
      quality: {
        title: "Qualité",
        description: "Nous utilisons uniquement des matériaux de première qualité et respectons les plus hauts standards de l'industrie."
      },
      reliability: {
        title: "Fiabilité", 
        description: "Nos équipes respectent les délais convenus et maintiennent une communication transparente tout au long du projet."
      },
      innovation: {
        title: "Innovation",
        description: "Nous intégrons les dernières technologies et tendances pour créer des espaces modernes et fonctionnels."
      },
      service: {
        title: "Service client",
        description: "Votre satisfaction est notre priorité. Nous offrons un service personnalisé et un suivi post-projet."
      }
    },

    // Footer
    footer: {
      tagline: "Votre partenaire de confiance en rénovation résidentielle.",
      quickLinks: "Liens Rapides", 
      ourServices: "Nos Services",
      contact: "Contact",
      copyright: "© 2025 AYMORENOV CONSTRUCTION INC. Tous droits réservés. cree par YVSS3R."
    },

    // Contact Info
    contact: {
      name: "Mohamed Obad",
      phone: "506-588-4919",
      email: "aymorenov25@gmail.com",
      address: "Nouveau-Brunswick, Canada"
    },

    // Contact Page
    contactPage: {
      title: "Contactez-nous",
      subtitle: "Parlons de votre projet de rénovation",
      description: "Notre équipe est là pour répondre à toutes vos questions et vous accompagner dans la réalisation de vos projets.",
      formTitle: "Envoyez-nous un message",
      nameLabel: "Nom complet",
      namePlaceholder: "Votre nom complet",
      emailLabel: "Adresse email",
      emailPlaceholder: "votre@email.com",
      phoneLabel: "Téléphone",
      phonePlaceholder: "Votre numéro de téléphone",
      serviceLabel: "Service demandé",
      servicePlaceholder: "Sélectionner un service",
      generalConsultation: "Consultation générale",
      urgencyLabel: "Urgence",
      urgencyLow: "Faible - Dans la semaine",
      urgencyNormal: "Normale - Sous 3 jours",
      urgencyHigh: "Élevée - Sous 24h",
      urgencyUrgent: "Urgente - Immédiatement",
      subjectLabel: "Sujet",
      subjectPlaceholder: "Objet de votre demande",
      messageLabel: "Message",
      messagePlaceholder: "Décrivez votre projet, vos besoins, ou posez vos questions...",
      sendButton: "Envoyer le Message",
      contactInfo: "Informations de Contact",
      getInTouch: "Restons en contact",
      officeHours: "Heures d'ouverture",
      whatsappCTA: "💬 WhatsApp Direct"
    },

    // Quote Page
    quotePage: {
      title: "Demande de devis gratuit",
      subtitle: "Obtenez une estimation personnalisée pour votre projet",
      description: "Remplissez ce formulaire détaillé pour recevoir un devis précis et adapté à vos besoins.",
      step1: "Informations personnelles",
      step2: "Détails du projet", 
      step3: "Préférences et budget",
      step4: "Confirmation",
      nextButton: "Suivant",
      prevButton: "Précédent",
      submitButton: "Envoyer la demande",
      thankYou: "Merci pour votre demande !",
      followUp: "Nous vous contacterons dans les plus brefs délais.",
      newQuote: "Nouvelle demande"
    }
  },

  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About",
      contact: "Contact", 
      quote: "Get Quote"
    },

    // Header
    header: {
      phone: "506-588-4919",
      email: "aymorenov25@gmail.com", 
      hours: "Mon-Fri: 8am-5pm | Sat: 9am-3pm",
      quoteButton: "Get Quote"
    },

    // Home Page
    home: {
      // Hero Section
      heroTitle: "Transform your home",
      heroSubtitle: "with AYMORENOV",
      heroTagline: "INTERIOR OR EXTERIOR, SMALL OR LARGE PROJECTS",
      heroTaglineSecond: "we take care of it!",
      heroDescription: "Your trusted partner for all your residential renovation projects.",
      whatsappButton: "💬 WhatsApp Contact",
      learnMoreButton: "Learn more",

      // Realizations Section
      realizationsTitle: "Our AYMORENOV Realizations",
      realizationsDescription: "Discover the quality of our work through these projects completed by Mohamed Obad and his team",
      flooringInstallation: "Flooring Installation",
      flooringDescription: "Professional finish",
      insulationWork: "Insulation & Structure",
      insulationDescription: "Expert construction",
      asphaltWork: "Hot/Cold Asphalt",
      asphaltDescription: "Quality driveways",
      kitchenRenovation: "Kitchen Renovation",
      kitchenDescription: "Modern design",
      realizationsCTA: "Contact us for your projects",

      // Services Section
      servicesTitle: "Our Renovation Services",
      servicesDescription: "Complete solutions for all your residential renovation needs",
      contactForQuote: "Contact us for a personalized quote",
      whatsappQuote: "💬 Request WhatsApp Quote",

      // Why Choose Us Section
      whyChooseTitle: "Why Choose AYMORENOV?",
      whyChooseDescription: "What sets us apart in the renovation industry",

      // Testimonials Section
      testimonialsTitle: "What our clients say",
      testimonialsDescription: "Our clients' satisfaction is our greatest reward",
      shareExperienceTitle: "Share your experience with AYMORENOV",
      shareExperienceDescription: "Your review helps us improve our services and guides other clients",
      yourName: "Your name",
      enterName: "Enter your name",
      city: "City",
      yourCity: "Your city",
      projectType: "Type of project completed",
      projectPlaceholder: "Ex: Kitchen renovation, Exterior paving...",
      yourRating: "Your rating",
      yourComment: "Your comment",
      commentPlaceholder: "Describe your experience with AYMORENOV...",
      publishReview: "Publish my review",

      // CTA Section
      ctaTitle: "Ready to Transform Your Home?",
      ctaDescription: "Contact Mohamed Obad today for a free consultation and discover how AYMORENOV can bring your renovation projects to life.",
      whatsappDirect: "💬 WhatsApp Direct",
      contactForm: "Contact Form"
    },

    // About Page
    about: {
      missionTitle: "Our mission",
      missionIntro: "Since its founding, AYMORENOV Construction inc. has established itself as a pillar of trust in the field of construction and renovation. Specialized in residential, commercial and industrial projects, our company combines traditional know-how and modern innovations to deliver durable, aesthetic results that meet the highest quality standards.",
      missionStatement: "Our mission is simple but ambitious: to realize your projects with professionalism, integrity and excellence. We are committed to:",
      commitment1: "Understanding your needs and expectations to offer you tailor-made solutions.",
      commitment2: "Using quality materials and proven techniques to guarantee durability and safety.",
      commitment3: "Respecting agreed deadlines and budgets, while maintaining transparent communication at every stage.",
      commitment4: "Promoting an eco-responsible approach, minimizing the environmental impact of our construction sites.",
      valuesTitle: "Our Core Values",
      valuesDescription: "What guides our daily work and makes us a trusted partner",
      ctaTitle: "Join the AYMORENOV Family",
      ctaDescription: "Trust our experience and passion to transform your home. Contact us today to start your project.",
      freeQuoteButton: "Request Free Quote",
      viewRealizationsButton: "View Our Work"
    },

    // Services Data
    services: {
      kitchenReno: {
        title: "Kitchen renovation",
        description: "Complete transformation of your kitchen with modern and functional design",
        features: ["Electricity and plumbing", "Tiling", "Equipment consultation"]
      },
      bathroomReno: {
        title: "Bathroom renovation",
        description: "Creating modern and accessible relaxation spaces",
        features: ["Plumbing", "Tiling and ceramics", "LED lighting", "Universal accessibility"]
      },
      exteriorReno: {
        title: "Exterior renovation",
        description: "Improving appearance and energy performance",
        features: ["Roofing", "Exterior siding", "Insulation", "Terraces and patios", "Garden exterior fencing"]
      },
      flooring: {
        title: "Flooring and coverings",
        description: "Installation of durable and aesthetic flooring",
        features: ["Hardwood", "Ceramic and porcelain", "Luxury vinyl", "Carpet and rugs"]
      },
      cleaning: {
        title: "Cleaning",
        description: "Cleaning after work completion",
        features: ["Post-construction cleaning"]
      },
      paving: {
        title: "Paving and asphalt",
        description: "Exterior paving and hot/cold asphalt",
        features: ["Exterior paving", "Hot/cold asphalt"]
      }
    },

    // Company Values
    values: {
      quality: {
        title: "Quality",
        description: "We only use top-quality materials and respect the highest industry standards."
      },
      reliability: {
        title: "Reliability",
        description: "Our teams respect agreed deadlines and maintain transparent communication throughout the project."
      },
      innovation: {
        title: "Innovation", 
        description: "We integrate the latest technologies and trends to create modern and functional spaces."
      },
      service: {
        title: "Customer service",
        description: "Your satisfaction is our priority. We offer personalized service and post-project follow-up."
      }
    },

    // Footer
    footer: {
      tagline: "Your trusted partner in residential renovation.",
      quickLinks: "Quick Links",
      ourServices: "Our Services", 
      contact: "Contact",
      copyright: "© 2025 AYMORENOV CONSTRUCTION INC. All rights reserved. created by YVSS3R."
    },

    // Contact Info
    contact: {
      name: "Mohamed Obad",
      phone: "506-588-4919",
      email: "aymorenov25@gmail.com",
      address: "New Brunswick, Canada"
    },

    // Contact Page
    contactPage: {
      title: "Contact Us",
      subtitle: "Let's talk about your renovation project",
      description: "Our team is here to answer all your questions and support you in bringing your projects to life.",
      formTitle: "Send us a message",
      nameLabel: "Full Name",
      namePlaceholder: "Your full name",
      emailLabel: "Email Address",
      emailPlaceholder: "your@email.com",
      phoneLabel: "Phone",
      phonePlaceholder: "Your phone number",
      serviceLabel: "Requested Service",
      servicePlaceholder: "Select a service",
      generalConsultation: "General Consultation",
      urgencyLabel: "Urgency",
      urgencyLow: "Low - Within a week",
      urgencyNormal: "Normal - Within 3 days",
      urgencyHigh: "High - Within 24h",
      urgencyUrgent: "Urgent - Immediately",
      subjectLabel: "Subject",
      subjectPlaceholder: "Subject of your request",
      messageLabel: "Message",
      messagePlaceholder: "Describe your project, needs, or ask your questions...",
      sendButton: "Send Message",
      contactInfo: "Contact Information",
      getInTouch: "Get in Touch",
      officeHours: "Office Hours",
      whatsappCTA: "💬 WhatsApp Direct"
    },

    // Quote Page
    quotePage: {
      title: "Free Quote Request",
      subtitle: "Get a personalized estimate for your project",
      description: "Fill out this detailed form to receive an accurate quote tailored to your needs.",
      step1: "Personal Information",
      step2: "Project Details",
      step3: "Preferences and Budget",
      step4: "Confirmation",
      nextButton: "Next",
      prevButton: "Previous",
      submitButton: "Submit Request",
      thankYou: "Thank you for your request!",
      followUp: "We will contact you as soon as possible.",
      newQuote: "New Request"
    }
  }
};